import storageService from './storageService';
import { COMPAT_KEYS, STORAGE_BACKENDS, STORAGE_DOMAINS, STORAGE_KEYS } from './storageKeys';

const isBrowser = typeof window !== 'undefined';

const readCompatJSON = (compatKey, fallbackValue) => {
    const rawValue = storageService.readRaw(compatKey, STORAGE_BACKENDS.LOCAL);
    const parsedValue = storageService.safeJsonParse(rawValue, fallbackValue);
    return parsedValue === undefined || parsedValue === null ? fallbackValue : parsedValue;
};

const writeCompatJSON = (compatKey, value) => {
    storageService.writeRaw(
        compatKey,
        JSON.stringify(value),
        STORAGE_BACKENDS.LOCAL,
        STORAGE_DOMAINS.PREFS
    );
};

export const getToggleState = () => {
    const namespacedState = storageService.getJSON(STORAGE_KEYS.toggleState, null);
    if (namespacedState && typeof namespacedState === 'object') {
        return namespacedState;
    }

    const compatState = readCompatJSON(COMPAT_KEYS.TOGGLE_STATE, undefined);
    if (compatState && typeof compatState === 'object') {
        storageService.setJSON(STORAGE_KEYS.toggleState, compatState);
        return compatState;
    }

    return undefined;
};

export const setToggleState = (state) => {
    storageService.setJSON(STORAGE_KEYS.toggleState, state);
    writeCompatJSON(COMPAT_KEYS.TOGGLE_STATE, state);
};

export const getVideoToggleState = () => {
    const namespacedState = storageService.getJSON(STORAGE_KEYS.videoToggleState, null);
    if (namespacedState && typeof namespacedState === 'object') {
        return namespacedState;
    }

    const compatState = readCompatJSON(COMPAT_KEYS.VIDEO_TOGGLE_STATE, undefined);
    if (compatState && typeof compatState === 'object') {
        storageService.setJSON(STORAGE_KEYS.videoToggleState, compatState);
        return compatState;
    }

    return undefined;
};

export const setVideoToggleState = (state) => {
    storageService.setJSON(STORAGE_KEYS.videoToggleState, state);
    writeCompatJSON(COMPAT_KEYS.VIDEO_TOGGLE_STATE, state);
};

export const getUserSelectedColumns = () => {
    const namespacedValue = storageService.getJSON(STORAGE_KEYS.userSelectedColumns, null);
    if (Array.isArray(namespacedValue)) {
        return namespacedValue;
    }

    const compatValue = readCompatJSON(COMPAT_KEYS.USER_SELECTED_COLUMNS, []);
    if (Array.isArray(compatValue)) {
        storageService.setJSON(STORAGE_KEYS.userSelectedColumns, compatValue);
        return compatValue;
    }

    return [];
};

export const setUserSelectedColumns = (columns) => {
    const normalizedColumns = Array.isArray(columns) ? columns : [];
    storageService.setJSON(STORAGE_KEYS.userSelectedColumns, normalizedColumns);
    writeCompatJSON(COMPAT_KEYS.USER_SELECTED_COLUMNS, normalizedColumns);
};

export const getFamSelectedColumns = () => {
    const namespacedValue = storageService.getJSON(STORAGE_KEYS.famSelectedColumns, null);
    if (Array.isArray(namespacedValue)) {
        return namespacedValue;
    }

    const compatValue = readCompatJSON(COMPAT_KEYS.FAM_SELECTED_COLUMNS, []);
    if (Array.isArray(compatValue)) {
        storageService.setJSON(STORAGE_KEYS.famSelectedColumns, compatValue);
        return compatValue;
    }

    return [];
};

export const setFamSelectedColumns = (columns) => {
    const normalizedColumns = Array.isArray(columns) ? columns : [];
    storageService.setJSON(STORAGE_KEYS.famSelectedColumns, normalizedColumns);
    writeCompatJSON(COMPAT_KEYS.FAM_SELECTED_COLUMNS, normalizedColumns);
};

export const hasWindowStorage = () => isBrowser;
